import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const BarGraphWrapper = forwardRef(({ newCount, inProgress, overdue, closed }, ref) => {
  const chartRef = useRef(null);

  const categories = ['New', 'In Progress', 'Overdue', 'Closed'];
  const values = [newCount, inProgress, overdue, closed];

  useImperativeHandle(
    ref,
    () => ({
      chart: chartRef.current?.chart,
      getChart: () => chartRef.current?.chart
    }),
    []
  );

  const colors = [
    {
      linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      stops: [
        [0, '#F7D94C'],
        [1, '#E5C600']
      ]
    },
    {
      linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      stops: [
        [0, '#6C8CFF'],
        [1, '#4A6EBE']
      ]
    },
    {
      linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      stops: [
        [0, '#EB5757'],
        [1, '#C0392B']
      ]
    },
    {
      linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      stops: [
        [0, '#C4C6CC'],
        [1, '#A6A8AA']
      ]
    }
  ];

  const options = {
    chart: {
      type: 'column',
      margin: [20, 10, 50, 40],
      style: { width: '100%' }
    },

    title: { text: '' },
    credits: { enabled: false },
    exporting: { enabled: false },
    legend: { enabled: false },

    xAxis: {
      categories,
      crosshair: true,
      labels: {
        style: { color: '#6E7686', fontSize: '13px' }
      }
    },

    yAxis: {
      min: 0,
      title: { text: '' },
      labels: { style: { color: '#6E7686', fontSize: '13px' } }
    },

    series: [
      {
        data: values,
        colorByPoint: true,
        colors,
        borderRadius: 3,

        pointWidth: null,

        dataLabels: {
          enabled: true,
          style: { fontWeight: 'bold', color: 'black' }
        }
      }
    ],
    tooltip: {
      useHTML: true,
      backgroundColor: '#000000',
      style: {
        color: '#FFFFFF'
      },
      formatter: function () {
        const category = categories[this.point.index];
        return `<div style="display: block; padding: 5px;">
                  <strong>${category}</strong><br/>
                  <div style="width: 10px; height: 10px; background-color: ${
                    colors[this.point.index].stops[0][1]
                  }; margin-right: 5px; display: inline-block;"></div>
                  Count: <b>${this.point.y}</b>
                </div>`;
      },
      shared: true
    },

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600
          },
          chartOptions: {
            chart: {
              margin: [10, 5, 40, 30]
            },
            xAxis: {
              labels: {
                style: { fontSize: '10px' }
              }
            },
            series: [
              {
                pointPadding: 0.2,
                groupPadding: 0.1,
                pointWidth: null,
                dataLabels: {
                  style: { fontSize: '10px' }
                }
              }
            ]
          }
        }
      ]
    }
  };

  return (
    <div style={{ width: '100%', overflowX: 'hidden' }}>
      <HighchartsReact ref={chartRef} highcharts={Highcharts} options={options} />
    </div>
  );
});

export default BarGraphWrapper;